module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_2-0c886456170b400e78eacc0bdcf5eef9.jpg";